export const EXTERNAL_API_EVENT = 'external-api-event';